import {
  Button,
  IconButton,
  Stack,
  TableCell,
  Tooltip,
} from "@mui/material";
import { ContentPaste, Description, FileDownload } from "@mui/icons-material";
import { GetBinary } from "../../../../../services/fhir/patientsummary/Binary/GetBinary";
import { useSessionContext } from "../../../../../contexts/SessionContext";
import { usePreferMobileCards } from "../../../context/EhrRecordsLayoutContext";
import {
  EhrMobileActionStack,
  ehrMobileActionBtnSx,
} from "../../mobile/EhrMobileActionStack";

export function ProcedureRequestActions({
  row,
  handleOpen,
  setBinaryUrl,
  openVisualizer,
  verifyVisualizer,
}: any) {
  const { access } = useSessionContext();
  const isMobileCardLayout = usePreferMobileCards();

  const base64ToBlob = (base64: any, contentType = "") => {
    const byteCharacters = atob(base64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  };

  async function downloadBase64File() {
    try {
      const response = await GetBinary({
        urlBinary: row?.binaryUrl,
      });
      const blob = base64ToBlob(response?.data, response?.contentType);
      const fileUrl = URL.createObjectURL(blob);
      window.open(fileUrl, "_blank");
    } catch (err) {
      console.log("err", err);
    }
  }

  const canViewEncounter =
    verifyVisualizer &&
    verifyVisualizer(row?.encounterId) &&
    access?.type === "professional";

  if (isMobileCardLayout) {
    if (!row?.binaryUrl) return null;

    return (
      <EhrMobileActionStack>
        <Button
          fullWidth
          variant="contained"
          color="primary"
          startIcon={<Description />}
          sx={ehrMobileActionBtnSx}
          onClick={() => {
            setBinaryUrl(row.binaryUrl);
            handleOpen();
          }}
        >
          Visualizar solicitação
        </Button>

        <Button
          fullWidth
          variant="outlined"
          color="primary"
          startIcon={<FileDownload />}
          sx={ehrMobileActionBtnSx}
          onClick={() => {
            downloadBase64File();
          }}
        >
          Baixar solicitação
        </Button>

        {canViewEncounter ? (
          <Button
            fullWidth
            variant="outlined"
            color="primary"
            startIcon={<ContentPaste />}
            sx={ehrMobileActionBtnSx}
            onClick={() => {
              openVisualizer(row?.encounterId);
            }}
          >
            Visualizar atendimento
          </Button>
        ) : null}
      </EhrMobileActionStack>
    );
  }

  return (
    <TableCell align="center">
      <Stack direction="row" justifyContent="center">
        {row?.binaryUrl ? (
          <>
            <Tooltip title="Visualizar solicitação">
              <IconButton
                onClick={() => {
                  setBinaryUrl(row.binaryUrl);
                  handleOpen();
                }}
              >
                <Description />
              </IconButton>
            </Tooltip>

            <Tooltip title="Baixar solicitação">
              <IconButton
                onClick={() => {
                  downloadBase64File();
                }}
              >
                <FileDownload />
              </IconButton>
            </Tooltip>

            {canViewEncounter ? (
              <Tooltip title="Visualizar atendimento">
                <IconButton
                  onClick={() => {
                    openVisualizer(row?.encounterId);
                  }}
                >
                  <ContentPaste />
                </IconButton>
              </Tooltip>
            ) : null}
          </>
        ) : null}
      </Stack>
    </TableCell>
  );
}
